import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"]': tw`py-0 px-2`,
    '& .MuiFilledInput-underline:before': tw`border-0`,
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"] .MuiAutocomplete-input': {
      ...tw`py-3 pr-8`,
    },
    '& .MuiFilledInput-root.Mui-focused': tw`bg-white`,
    '& .MuiFilledInput-underline:after': tw`border-0`,
  },
  input: (fontSizeStyle = {}) => ({
    '&': {
      ...tw`flex items-center relative border border-gray-500 border-solid border-opacity-10 px-2 bg-grey-500 bg-opacity-5 w-full h-full rounded-2xl`,
      'font-family': 'var(--fontFamilyBody)',
    },
    '&::placeholder': { ...tw`placeholder-gray-500`['::placeholder'], opacity: '1' },
    '&:before': tw`border-0`,
    textIndent: '1rem',
    ...fontSizeStyle,
  }),
  inputRoot: {
    '&:hover, &:focus, &:active': tw`bg-white`,
    '&': { ...tw`bg-white py-3`, 'font-family': 'var(--fontFamilyBody)' },
  },
  focused: tw`bg-white`,
  paper: (fontSizeStyle = {}) => ({
    marginTop: 'unset',
    borderTopLeftRadius: 'unset',
    borderTopRightRadius: 'unset',
    boxShadow: 'unset',
    ...fontSizeStyle,
  }),
  popperDisablePortal: {
    position: 'relative',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));
